import { Row, Column } from '@simplywallst/ui-core';
import { Stats, Label, TipContainer } from './styled';
import Tooltip from '@components/Tooltip';
import useGlossaryTerms from '@/hooks/useGlossaryTerms';
import { useOverviewTranslation } from '@/pages/CompanyReport/components/OverviewSection/hooks/useOverviewTranslation';

interface DividendStatsProps {
  dividendYield?: string;
  payoutRatio?: string;
}
const DividendStats = ({ dividendYield, payoutRatio }: DividendStatsProps) => {
  const getTerm = useGlossaryTerms();
  const dividendYieldTerm = getTerm('current dividend yield');
  const payoutRatioTerm = getTerm('payout ratio');

  const t = useOverviewTranslation();

  return (
    <Row>
      {dividendYield && (
        <Column col={6}>
          <Stats>{dividendYield}</Stats>
          <Tooltip
            openDelay={300}
            light
            title={<TipContainer>{dividendYieldTerm}</TipContainer>}
          >
            <Label>{t('fundamentals.dividend.currentYield')}</Label>
          </Tooltip>
        </Column>
      )}
      {payoutRatio && (
        <Column col={6} displayFlex alignItem="flex-end">
          <div>
            <Stats>{payoutRatio}</Stats>
            <Tooltip
              openDelay={300}
              light
              title={<TipContainer>{payoutRatioTerm}</TipContainer>}
            >
              <Label>{t('fundamentals.dividend.payoutRatio')}</Label>
            </Tooltip>
          </div>
        </Column>
      )}
    </Row>
  );
};
export default DividendStats;
